import { useFeatureFlag } from '@src/hooks/useFeatureFlag';
import type { SoundMap } from '@src/providers/SoundProvider/soundUtils';
import { isCypressWindow, type ModeEnum, type Order } from '@talos/kyoko';
import { isCypressE2E } from '../../../../../packages/kyoko/src/utils/envCypress';
import { AppNotificationsMonitor } from './AppNotificationsMonitor';

export type AppNotificationPriority = 'High' | 'Medium' | 'Low';
type AppNotificationTargetState = 'New' | 'Archived' | 'Withdrawn';

/** Server type for AppNotification
 * TODO: get it from sbe-generated type
 */
type AppNotificationBase = {
  NotificationID: string;
  OrgID: number;
  Timestamp: string;
  Severity: AppNotificationPriority;
  Type: AppNotificationOrderType['Type'];
  State: AppNotificationTargetState;
  SoundMode?: ModeEnum;
  SoundSelection?: '' | keyof typeof SoundMap;
  User?: string;
};

export type AppNotificationOrderType = {
  Type: 'OrderStatus';
  SubType: `Order${string}`;
  /** Order type is here is enough to construct an order */
  Payload: Order;
};

export type AppNotification = AppNotificationBase & AppNotificationOrderType;

/** Run AppNotificationsMonitor based on feature flag
 * - Since this is used in ContextProvider, we want to protect against Cypress testing, except
 * for specific tests that need it.
 */
export const AppNotificationsMonitorContainer: React.FC = () => {
  const { enableNotifications } = useFeatureFlag();

  // if cypress is component testing, don't kick off cypress notifications
  return !enableNotifications || (isCypressWindow(window) && !isCypressE2E(window)) ? null : (
    <AppNotificationsMonitor />
  );
};
